"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabConfig = exports.TabEnum = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _MenuBadge = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/MenuBadge"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H6"));

var _TabConfig;

var DiscountBadgeContainer = _styledComponents.default.div.withConfig({
  displayName: "TabConfig__DiscountBadgeContainer",
  componentId: "sc-18s5ack-0"
})(["position:absolute;top:-11px;width:100%;"]);

var TabDiscountBadge = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "TabConfig__TabDiscountBadge",
  componentId: "sc-18s5ack-1"
})(["margin:0;font-weight:bold;font-size:8pt;"]);
var TabEnum = {
  PRODUCTS: 'products',
  BUNDLE: 'bundle',
  CRM: 'crm',
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  CMS: 'cms',
  GROWTH_SUITE: 'growth-suite',
  CREATE_BUNDLE: 'create-a-bundle'
};
exports.TabEnum = TabEnum;
var TabConfig = (_TabConfig = {}, (0, _defineProperty2.default)(_TabConfig, TabEnum.PRODUCTS, [{
  id: TabEnum.CRM,
  title: function title() {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.tabTitle"
    });
  },
  mobileKey: 'pricingPage.pages.crm.tabTitle',
  mobileCategory: 'pricingPage.pages.products.tabTitle'
}, {
  id: TabEnum.MARKETING,
  title: function title() {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.marketing.tabTitle"
    });
  },
  mobileKey: 'pricingPage.pages.products.tabs.marketing.tabTitle',
  mobileCategory: 'pricingPage.pages.products.tabTitle'
}, {
  id: TabEnum.SALES,
  title: function title() {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.sales.tabTitle"
    });
  },
  mobileKey: 'pricingPage.pages.products.tabs.sales.tabTitle',
  mobileCategory: 'pricingPage.pages.products.tabTitle'
}, {
  id: TabEnum.SERVICE,
  title: function title() {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.service.tabTitle"
    });
  },
  mobileKey: 'pricingPage.pages.products.tabs.service.tabTitle',
  mobileCategory: 'pricingPage.pages.products.tabTitle'
}, {
  id: TabEnum.CMS,
  title: function title() {
    return _react.default.createElement("div", {
      className: "justify-center align-center"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.cmsHub.tabTitle"
    }), _react.default.createElement(_MenuBadge.default, {
      style: {
        marginBottom: 2
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: 'pricingPage.new'
    })));
  },
  mobileKey: 'pricingPage.pages.products.tabs.cmsHub.tabTitle',
  mobileBadge: function mobileBadge() {
    return _react.default.createElement(_MenuBadge.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.new"
    }));
  },
  mobileCategory: 'pricingPage.pages.products.tabTitle'
}]), (0, _defineProperty2.default)(_TabConfig, TabEnum.BUNDLE, [{
  id: TabEnum.GROWTH_SUITE,
  title: function title(_ref) {
    var isHSFXEligible = _ref.isHSFXEligible,
        discountBadgeKey = _ref.discountBadgeKey;
    return _react.default.createElement("div", {
      style: {
        position: 'relative'
      }
    }, !isHSFXEligible && _react.default.createElement(DiscountBadgeContainer, null, _react.default.createElement(TabDiscountBadge, null, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.growthSuite." + discountBadgeKey
    }))), _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.growthSuite.tabTitle"
    }));
  },
  mobileKey: 'pricingPage.pages.products.tabs.growthSuite.tabTitle',
  mobileBadge: function mobileBadge(_ref2) {
    var isHSFXEligible = _ref2.isHSFXEligible,
        discountBadgeKey = _ref2.discountBadgeKey;
    return !isHSFXEligible && _react.default.createElement(_MenuBadge.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.growthSuite." + discountBadgeKey
    }));
  },
  mobileCategory: 'pricingPage.productCategories.bundles'
}, {
  id: TabEnum.CREATE_BUNDLE,
  slug: 'bundle',
  title: function title() {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.bundle.tabTitle"
    });
  },
  mobileKey: 'pricingPage.pages.bundle.tabTitle',
  mobileCategory: 'pricingPage.productCategories.bundles'
}]), _TabConfig);
exports.TabConfig = TabConfig;